/* @flow */
import type Step from './step'

export type StepListEntryType = { name: string, class: Step<any> }
export type StepListType = Array<StepListEntryType>

/**
 * CurrentStep
 * @param {Array} steps
 * @param {Object} step
 */
class CurrentStep {
  steps: StepListType
  step: StepListEntryType
  index: number
  stepComponent: React$Component<any, any>
  name: string
  totalSteps: number
  stepNumber: number

  constructor(steps: StepListType, step: StepListEntryType) {
    this.steps = steps
    this.step = step
    this.index = steps.indexOf(step)

    this.stepComponent = this.step.class
    this.name = this.step.name
    this.totalSteps = this.steps.length
    this.stepNumber = this.index + 1
  }

  get nextStep(): CurrentStep {
    const next: ?StepListEntryType = this.steps[this.index + 1]
    return next ? new CurrentStep(this.steps, next) : this
  }

  get previousStep(): CurrentStep {
    const previous: ?StepListEntryType = this.steps[this.index - 1]
    return previous ? new CurrentStep(this.steps, previous) : this
  }

  get isLast(): boolean {
    return !this.steps[this.index + 1]
  }

  get isFirst(): boolean {
    return !this.steps[this.index - 1]
  }
}

export default CurrentStep
